import {Injectable} from '@angular/core';
import {EloquentManagerService} from "../../eloquent/providers/eloquent-manager.provider";
import {Content} from "../../eloquent/models/content.model";

@Injectable()
export class ContentService {


    private content;

    constructor(private eloquentManagerService: EloquentManagerService) {
    }


    public loadContent = () => {
        this.eloquentManagerService.getById(Content, 1).subscribe((response) => {
            if (response) {
                this.content = response;
                console.log(this.content);
            }
        });
    }

    
    public getContentByKey = (key) => {
        return (this.content[key]) ? this.content[key] : false;
    }

}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/services/content/content.service.ts